module.exports = __webpack_public_path__ + "static/media/lewy-gora-atmo.0469616d.svg";